import * as audioplayer from 'audioplayer';
import * as contentloader from 'contentloader';
import * as newsloader from 'newsloader';
import * as horizonscroller from 'horizonscroller';

audioplayer.init();
contentloader.init();
newsloader.init();
horizonscroller.init();



//////////////////
// WEBPACK FOOTER
// ./public/js/app.js
// module id = 6
// module chunks = 0